'use es6';

import formatName from 'I18n/utils/formatName';
import { ACHIEVEMENT_VISIBILITIES } from '../constants/AchievementConstants';
import { slugify, usernameFromEmail } from '../utils/utils';
export const getAchievementCreationData = (state, ownProps) => {
  const {
    award,
    track,
    trackId
  } = ownProps;
  const {
    email,
    firstName,
    lastName
  } = state.auth.user;
  const userName = firstName || lastName ? formatName({
    firstName,
    lastName
  }) : usernameFromEmail(email);
  return {
    firstName,
    lastName,
    email,
    urlSlug: `${slugify(userName)}/${slugify(track.name)}`,
    visibilityType: award.isPubliclyVisible ? ACHIEVEMENT_VISIBILITIES.PUBLIC : ACHIEVEMENT_VISIBILITIES.PRIVATE,
    language: track.language,
    trackId
  };
};